import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Spinner } from '../common';
import { cambiarStringApp, getArticulosEnAPI } from '../../actions';
import ModalError from '../common/ModalError';
import history from '../../history';
import './Portada.css';

class Portada extends Component {
  constructor(props) {
    super(props);

    this.header = React.createRef();
  }

  componentDidMount() {
    this.props.cambiarStringApp('cabecera_titulo', 'cabecerasTitulos.portada');
    this.props.cambiarStringApp('cabecera_titulo_s', 'cabecerasTitulos.portada_s');
    this.props.cambiarStringApp('cabecera_titulo_xs', 'cabecerasTitulos.portada_xs');
    this.props.cambiarStringApp('cabecera_subtitulo', 'cabecerasSubtitulos.portada');
    this.props.cambiarStringApp('sr_only', 'sr_only.portada');

    if (this.props.viene_de_articulo === true) {
      this.props.cambiarStringApp('viene_de_articulo', false);
    } else {
      this.props.getArticulosEnAPI(0, this.props.articulos_limit, [], []);
    }

    if (this.props.match.params.idioma !== 'es') { history.replace(`/${this.props.idioma}/`); }
  }

  componentDidUpdate() {
    if (this.props.articulos_jump === true) {
      this.header.current.scrollIntoView({ behavior: 'smooth' });
      this.props.cambiarStringApp('articulos_jump', false);
    }
  }

  handleClickEtiquetas = etiqueta => {
    if (this.props.articulos_filtros.includes(etiqueta.currentTarget.textContent)) {
      this.header.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      const filtros = this.props.articulos_filtros;
      filtros.push(etiqueta.currentTarget.textContent);
      filtros.sort();

      this.props.cambiarStringApp('articulos_filtros', filtros);

      this.props.getArticulosEnAPI(0, this.props.articulos_limit, this.props.articulos_filtros, [], true); // El último true es para que haga el salto del scroll
    }
  }

  handleClickQuitarEtiqueta = async etiqueta => {
    const filtros = await this.props.articulos_filtros.filter(filtro => {
      return etiqueta.currentTarget.textContent !== filtro;
    });

    this.props.cambiarStringApp('articulos_filtros', filtros);

    this.props.getArticulosEnAPI(0, this.props.articulos_limit, filtros, [], true);
  }

  handleClickQuitarFiltros = () => {
    this.props.cambiarStringApp('articulos_filtros', []);

    this.props.getArticulosEnAPI(0, this.props.articulos_limit, [], [], true);
  }

  handleClickBotonCargarMas = () => {
    this.props.getArticulosEnAPI(this.props.articulos_skip, this.props.articulos_limit, this.props.articulos_filtros, this.props.articulos_portada);
  }

  renderArticulos() {
    const articulos = [];
    this.props.articulos_portada.forEach(articulo => {
      const etiquetado = [];
      articulo.etiquetas.sort();
      articulo.etiquetas.forEach((etiqueta, key) => {
        const etiq = (<p className="etiquetas" key={key} onClick={this.handleClickEtiquetas}>{etiqueta}</p>);
        etiquetado.push(etiq);
      });

      // const date = new Date(articulo.fecha_alta);

      const resumen = [];
      articulo.resumen.split(':-:br:-:').forEach((parrafo, key) => {
        resumen.push(<p key={key}>{parrafo}</p>);
      });

      const art = (
        <>
          <article className="col-pxxxl-50 col-pxxl-32 col-pxl-20 col-pl-20 col-pm-16 col-ps-16 col-pxs-16 col-pxxs-16 col-xxl-12 col-xl-12 col-l-12 col-m-12 col-s-12 col-xs-12 col-xxs-12 cajaArticulo margenInferiorMinMed" key={articulo._id}>
            <Link title={articulo.titulo} to={`/${this.props.idioma}/${articulo.slug}`}>
              <header>
                <h2 className="fontBold fontBig textoAzul linkArticulo">{articulo.titulo}</h2>
              </header>
              <hr className="cabecera" />
              { /*     <p className="fontMed textoClaro">Por {articulo.nombre} el {date.toLocaleDateString()}</p>            DESCOMENTAR PARA SACAR LAS FECHAS         */ }
              <div className="textoWeb textoJustificado">{resumen}</div>
            </Link>
          </article>
          <div className="cajaEtiquetas margenInferiorBigMedBig">
            <p className="fontMed textoClaro margenInferiorMinMin">Artículo creado por {articulo.nombre} | LinkedIn <a className="linkAzulAzulClaro" href={`https://www.linkedin.com/in/${articulo.linkedin}`}>@{articulo.linkedin}</a></p>
            <p className="textoEtiquetas margenDerechaMinMed margenInferiorMinMin">Etiquetado en</p>
            {etiquetado}
          </div>
        </>
      );

      articulos.push(art);
    });

    return articulos;
  }

  renderFiltros() {
    if (this.props.articulos_filtros.length !== 0) {
      const { t } = this.props;
      const etiquetado = [];

      this.props.articulos_filtros.forEach((etiqueta, key) => {
        const etiq = (<p className="etiquetas" key={key} onClick={this.handleClickQuitarEtiqueta}><i className="fas fa-times margenDerechaMin" />{etiqueta}</p>);
        etiquetado.push(etiq);
      });

      return (
        <>
          <div className="col-pxxxl-50 col-pxxl-32 col-pxl-20 col-pl-20 col-pm-16 col-ps-16 col-pxs-16 col-pxxs-16 col-xxl-12 col-xl-12 col-l-12 col-m-12 col-s-12 col-xs-12 col-xxs-12 margenInferiorMinMed">
            <p className="etiquetas" onClick={this.handleClickQuitarFiltros}>
              <i className="fas fa-times margenDerechaMin" />{t('quitarFiltros')}
            </p>
          </div>

          <div className="col-pxxxl-50 col-pxxl-32 col-pxl-20 col-pl-20 col-pm-16 col-ps-16 col-pxs-16 col-pxxs-16 col-xxl-12 col-xl-12 col-l-12 col-m-12 col-s-12 col-xs-12 col-xxs-12 margenInferiorMed">
            {etiquetado}
          </div>
        </>
      );
    }

    return null;
  }

  renderBotonCargarMas() {
    if (this.props.spinner_app === true) {
      return <div style={{ margin: '60px 0 170px 0' }}><Spinner /></div>;
    }

    if (this.props.articulos_cargar_mas === true) {
      const { t } = this.props;

      return (
        <div className="contenedor">
          <div className="col-pxxxl-5 col-pxxl-5 col-pxl-3 col-pl-2 col-pm-1 col-ps-2 col-pxs-2 col-pxxs-3 col-xxl-2 col-xl-2 col-l-2 col-m-3 hidden-s hidden-xs hidden-xxs">&nbsp;</div>
          <div className="col-pxxxl-40 col-pxxl-22 col-pxl-14 col-pl-16 col-pm-14 col-ps-13 col-pxs-14 col-pxxs-13 col-xxl-10 col-xl-10 col-l-10 col-m-9 col-s-12 col-xs-12 col-xxs-12 cajeadoHorizontal" style={{ marginBottom: '-60px' }}>
            <button className="botonCargarMas" name="botonCargarMas" onClick={this.handleClickBotonCargarMas} type="submit" value="botonCargarMas">{t('cargarMas')}</button>
          </div>
          <div className="col-pxxxl-5 col-pxxl-5 col-pxl-3 col-pl-2 col-pm-1 col-ps-1 hidden-pxs hidden-pxxs hidden-xxl hidden-xl hidden-l hidden-m hidden-s hidden-xs hidden-xxs">&nbsp;</div>
        </div>
      );
    }

    return null;
  }

  render() {
    const { t } = this.props;

    return (
      <>
        <ModalError texto={this.props.error_app} textoCancelar={t('common:modalError.cerrar')} visible={this.props.mostrar_error_app} />

        <section className="contenedor maxWidth margenInferiorBig">
          <header className="cajeadoHorizontal margenInferiorBigMedBig" ref={this.header}>
            <h2 className="hidden-pxxs hidden-xxl hidden-xl hidden-l hidden-m hidden-s hidden-xs hidden-xxs textoAzul fontBold fontH1 textoCentrado">{t('titular.titulo')}</h2>
            <h2 className="hidden-pxxxl hidden-pxxl hidden-pxl hidden-pl hidden-pm hidden-ps hidden-pxs hidden-s hidden-xs hidden-xxs textoAzul fontBold fontH1 textoCentrado">{t('titular.titulo_s')}</h2>
            <h2 className="hidden-pxxxl hidden-pxxl hidden-pxl hidden-pl hidden-pm hidden-ps hidden-pxs hidden-pxxs hidden-xxl hidden-xl hidden-l hidden-m textoAzul fontBold fontH1 textoCentrado">{t('titular.titulo_xs')}</h2>
            <hr className="separacion" />
            <p className="textoCentradoJustificado">{t('titular.subtitulo')}</p>
          </header>

          <div className="contenedor">
            <div className="col-pxxxl-5 col-pxxl-5 col-pxl-3 col-pl-2 col-pm-1 col-ps-2 col-pxs-2 col-pxxs-3 col-xxl-2 col-xl-2 col-l-2 col-m-3 hidden-s hidden-xs hidden-xxs">
              <p className="etiquetas enColumna" onClick={this.handleClickEtiquetas}>Animaciones</p>
              <p className="etiquetas enColumna" onClick={this.handleClickEtiquetas}>Docker</p>
              <p className="etiquetas enColumna" onClick={this.handleClickEtiquetas}>Firewall</p>
              <p className="etiquetas enColumna" onClick={this.handleClickEtiquetas}>Hooks</p>
              <p className="etiquetas enColumna" onClick={this.handleClickEtiquetas}>Programación</p>
              <p className="etiquetas enColumna" onClick={this.handleClickEtiquetas}>React</p>
              <p className="etiquetas enColumna" onClick={this.handleClickEtiquetas}>Seguridad</p>
              <p className="etiquetas enColumna" onClick={this.handleClickEtiquetas}>Sistemas</p>
            </div>

            <div className="col-pxxxl-40 col-pxxl-22 col-pxl-14 col-pl-16 col-pm-14 col-ps-13 col-pxs-14 col-pxxs-13 col-xxl-10 col-xl-10 col-l-10 col-m-9 col-s-12 col-xs-12 col-xxs-12 cajeadoHorizontal" style={{ marginBottom: '-60px' }}>
              {this.renderFiltros()}
              {this.renderArticulos()}
            </div>

            <div className="col-pxxxl-5 col-pxxl-5 col-pxl-3 col-pl-2 col-pm-1 col-ps-1 hidden-pxs hidden-pxxs hidden-xxl hidden-xl hidden-l hidden-m hidden-s hidden-xs hidden-xxs">&nbsp;</div>
          </div>

          {this.renderBotonCargarMas()}
        </section>
      </>
    );
  }
}

const mapStateToProps = ({ app }) => {
  const { viene_de_articulo, idioma, articulos_portada, articulos_skip, articulos_limit, articulos_cargar_mas, articulos_filtros, articulos_jump, spinner_app, error_app, mostrar_error_app } = app;

  return { viene_de_articulo, idioma, articulos_portada, articulos_skip, articulos_limit, articulos_cargar_mas, articulos_filtros, articulos_jump, spinner_app, error_app, mostrar_error_app };
};

// Esta funciona pero la siguiente es más elegante
// export default connect(mapStateToProps, { cambiarStringApp })(withTranslation()(Portada));
export default compose(
  connect(mapStateToProps, { cambiarStringApp, getArticulosEnAPI }),
  withTranslation('blog')
)(Portada);
